export const isBusiness42Receptionist = user =>
  Number(user?.business_id ?? user?.business?.id) == 42 &&
  String(user?.role?.name_en || user?.role?.name || '').toLowerCase() === 'receptionist'

export const shouldSkipInitialBillingLoad = user => isBusiness42Receptionist(user)

export const hasBillingSearchFilters = payload =>
  [payload?.query, payload?.file_number, payload?.document_id, ...Object.values(payload?.filters || {})]
    .some(value => String(value ?? '').trim() !== '')

export const omitBillingDatesForSkipInitialLoad = (user, payload = {}) => {
  if (!shouldSkipInitialBillingLoad(user)) return payload
  const { start_date, end_date, ...payloadWithoutDates } = payload
  return payloadWithoutDates
}

export const getReceptionistDiscountLimit = (user, discountSettings) => {
  const limit = Number(discountSettings?.default_limit ?? discountSettings?.receptionist_discount_limit ?? user?.settings?.discount_settings?.default_limit ?? 100)
  return Number.isFinite(limit) && limit >= 0 && limit <= 100 ? limit : 100
}

export const getDepartmentDiscountLimit = (user, departmentId, discountSettings) => {
  const settings = discountSettings || user?.settings?.discount_settings || {}
  const match = (settings.department_limits || []).find(item => String(item.department_id) === String(departmentId))
  const limit = Number(match?.limit ?? settings.default_limit ?? 100)
  return Number.isFinite(limit) && limit >= 0 && limit <= 100 ? limit : 100
}

const EMR_DISCOUNT_HIDDEN_BUSINESS_IDS = [45]
const EMR_UNIT_PRICE_DISABLED_BUSINESS_IDS = [45, 1]
const EMR_UNIT_PRICE_HIDDEN_BUSINESS_IDS = [42]
const DATE_OF_BIRTH_VISIBILITY_BUSINESS_IDS = [45, 1]

const getBusinessId = user => Number(user?.business_id ?? user?.business?.id)

export const isHideEmrDiscount = user =>
  EMR_DISCOUNT_HIDDEN_BUSINESS_IDS.includes(getBusinessId(user))

export const isDisableEmrUnitPrice = user =>
  EMR_UNIT_PRICE_DISABLED_BUSINESS_IDS.includes(getBusinessId(user))

export const isHideEmrUnitPrice = user =>
  String(user?.role?.name_en || user?.role?.name || '').toLowerCase() ===
  'practitioner' &&
  EMR_UNIT_PRICE_HIDDEN_BUSINESS_IDS.includes(getBusinessId(user))

export const isShowDateOfBirth = user =>
  // String(user?.role?.name_en || user?.role?.name || '').toLowerCase() === 'practitioner' &&
  DATE_OF_BIRTH_VISIBILITY_BUSINESS_IDS.includes(getBusinessId(user))
